import React from 'react';

const Footer = () => {

    return (
        <div className="p-4" style={{ backgroundColor: '#18122B' }}>
            <h6 className="text-center text-white">&#169; All Rights Reserved to Md.Al-Amin</h6>
        </div>
    );
};

export default Footer;